<!-- eslint-disable vue/no-bare-strings-in-template -->
<script setup>
import { ref, watch } from 'vue';
import Modal from 'dashboard/components/Modal.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { updateFunnelConfiguration } from 'dashboard/api/aceleres/funilConfiguration';

const props = defineProps({
  show: Boolean,
  accountId: { type: [String, Number], default: '' },
  funnel: { type: Object, default: null },
});
const emit = defineEmits(['update:show', 'saved', 'open-assistant']);
const form = ref({ description: '', entry_criteria: '' });
const saving = ref(false);
const error = ref('');

watch(
  () => props.funnel,
  value => {
    form.value = {
      description: value?.description || '',
      entry_criteria: value?.entry_criteria || '',
    };
    error.value = '';
  },
  { immediate: true }
);

const save = async () => {
  if (!props.funnel || saving.value) return;
  saving.value = true;
  error.value = '';
  try {
    await updateFunnelConfiguration(
      props.accountId,
      props.funnel.id,
      form.value
    );
    emit('saved', { ...props.funnel, ...form.value });
    emit('update:show', false);
  } catch (e) {
    error.value = e.message;
  } finally {
    saving.value = false;
  }
};
</script>

<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <Modal
    :show="show"
    :on-close="() => emit('update:show', false)"
    @close="emit('update:show', false)"
  >
    <form class="flex flex-col gap-4 p-8" @submit.prevent="save">
      <div class="flex items-center justify-between gap-3">
        <h2 class="text-lg font-medium text-n-slate-12">Configurar funil</h2>
        <NextButton
          type="button"
          faded
          slate
          label="Desenhar com IA"
          @click="emit('open-assistant')"
        />
      </div>
      <p class="text-sm text-n-slate-11">{{ funnel?.name || 'Funil' }}</p>
      <label
        >O que é este funil?<textarea v-model="form.description" rows="4" />
      </label>
      <label
        >Critério para uma conversa entrar aqui<textarea
          v-model="form.entry_criteria"
          rows="4"
        />
      </label>
      <span v-if="error" class="text-xs text-n-ruby-11">{{ error }}</span>
      <div class="flex justify-end gap-2">
        <NextButton
          type="button"
          faded
          slate
          label="Cancelar"
          @click="emit('update:show', false)"
        /><NextButton type="submit" label="Salvar" :is-loading="saving" />
      </div>
    </form>
  </Modal>
</template>
